export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '35d3b2e', dateTime: 1792100512339 };